import * as types from './auth.types';

export const authSelectors: types.IAuthSelectors = {
  selectLoggedUser: (state) => state.auth.loggedUser,
  selectAccessToken: (state) => state.auth.accessToken,
  selectGoogleGrantedPermision: (state) => state.auth.googleGrantedPermision,
  selectRememberUser: (state) => state.auth.rememberUser,
  selectUserExpiresAt: (state) => state.auth.userExpiresAt,
  selectUserIsAdmin: (state) => state.auth.userIsAdmin,
  selectRedirectAfterLogin: (state) => state.auth.redirectAfterLogin,
};
